import { useEffect, useRef, useState } from 'react'
import type { ContactsView } from './StaffContactsView.types'
import { initialStaffView } from './initialStaffView'
import { subscribeLocation } from './timelineFilters'

export function useStaffView() {
  const [view, setView] = useState<ContactsView>(() => initialStaffView())
  const pathname = useRef(window.location.pathname)
  useEffect(
    () =>
      subscribeLocation(() => {
        // Query-only history belongs to the mounted page (tabs, filters and drafts).
        if (pathname.current === window.location.pathname) return
        pathname.current = window.location.pathname
        setView(initialStaffView())
      }),
    [],
  )
  const navigateTo = (nextView: ContactsView, path: string) => {
    window.history.pushState({}, '', path)
    pathname.current = window.location.pathname
    setView(nextView)
  }
  return { view, setView, navigateTo }
}
